// How far a stepper lets the user jump between steps.
export enum StepperNavMode {
  /** Any step is reachable at any time. */
  FREE = 'free',
  /** Only steps already reached, plus the next one. */
  SEQUENTIAL = 'sequential',
}

// What asked for a step change. Lets a step veto arbitrary jumps without the
// feedback it would show when the user actually pressed Continue.
export enum StepperNavSource {
  /** A direct jump: the tabs, or a step component calling goToStep. */
  JUMP = 'jump',
  /** One step at a time, from the footer's Back or Continue. */
  FOOTER = 'footer',
}
